import React from 'react';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';

const AsyncInfoPage = Load(() => import(/* webpackChunkName: "info-pages" */'./components/InfoPage'), {}, true);

const InfoPagesRoutes = [
  (
    <NavigationableLayout
      key="prismic"
      path={`${basePath}/info/:uid/`}
      component={AsyncInfoPage}
    />
  ),
];

export default InfoPagesRoutes;
